module.exports = __webpack_public_path__ + "static/media/t52.0f70806d.jpg";